/* eslint-disable */

import { useConfig } from '../config'
import { useVuetify } from '../_vuetify';

export function registerPlugins(app) {
  useConfig(app);
  useVuetify(app);
}